<template>
  <v-container class="full">
    <v-layout justify-center row class="top">
      <v-flex lg10 md10 sm10 sx12>
        <v-flex lg10 md10 sm12 sx12>
          <v-layout justify-center>
            <v-flex class="pull" lg4 md4 sm12 sx12>
              <h1 class="h1">Planificación Estratégica 2030</h1>
            </v-flex>
            <v-flex class="line" lg1 md1 sm1 sx1 hidden-sm-and-down></v-flex>
            <v-layout align-center hidden-sm-and-down>
              <v-flex lg7 md7 sm3 sx12>
                <h1 class="h2">{{this.ccComplete.ccNombre}}</h1>
              </v-flex>
            </v-layout>
          </v-layout>
        </v-flex>
      </v-flex>
    </v-layout>
    <v-layout row>
      <v-flex class="line2" lg4 md4 sm12 sx12 hidden-md-and-up>
        <h4 v-if="this.ccComplete.esMayor == false">{{this.ccComplete.ccNombre}}</h4>
        <h3 v-if="this.ccComplete.esMayor == true">{{this.ccComplete.ccNombre}}</h3>
      </v-flex>
    </v-layout>
  <br/>
    <v-layout row class="bot">
      <v-flex offset-xs0 offset-md1 offset-lg0 offset-sm0 md7 lg8 xs12 sm11>
        <!-- video -->
          <v-flex md12 lg12 xs12 sm12>
            <v-carousel height="350px" :cycle="false" hide-delimiters class="carousel">
              <v-carousel-item v-for="(item,i) in carousel" :key="i" :src="item"></v-carousel-item>
            </v-carousel>
          </v-flex>
        <v-flex class="containerStyle2" md12 lg12 xs12 sm12 v-if="this.$session.getAll().userType != 'Vicerrector' && (this.$session.getAll().userType == 'dge' &&  this.$session.getAll().ccData.tipo != 'Vicerrectoria')">
          <v-layout class="mid-dialog-card">
            <v-flex md12 lg12 xs12 sm12 xl12>
              <v-layout class="upper-card" align-center justify-center fill-height>
                <v-layout>
                  <v-flex md12 lg12 xs12 sm12>
                    <h4 style="margin-top:0">Misión Actual</h4>
                    <p class="text-mision">{{this.misionActual}}</p>
                  </v-flex>
                </v-layout>
              </v-layout>
            </v-flex>
          </v-layout>
          <v-layout class="mid-dialog-card">
            <v-flex md12 lg12 xs12 sm12 xl12>
              <v-layout class="lower-card" align-center justify-center fill-height>
                <v-layout>
                  <v-flex md12 lg12 xs12 sm12>
                    <h4 class="titlep">Visión Actual</h4>
                    <p class="text-mision-propuesta">{{this.visionActual}}</p>
                  </v-flex>
                </v-layout>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-flex>

      <v-flex md1.5 lg xs0 sm0 hidden-sm-and-down>
        <v-navigation-drawer floating permanent stateless class="drawner" value="true">
          <v-list dense>
            <v-list-tile>
              <v-list-tile-content>
                <v-list-tile-title class="v-list-new">
                  <v-btn
                    small
                    color="#EB7704"
                    class="button"
                    @click="downloadFile(20)"
                  >PEI 2020 - 2030</v-btn>
                </v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile>
              <v-list-tile-content>
                <v-list-tile-title class="v-list-new">
                  <v-btn
                    small
                    color="#EB7704"
                    class="button"
                    @click="downloadFile(21)"
                  >Afiche pei 2030</v-btn>
                </v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <!-- <v-list-tile>
              <v-list-tile-content>
                <v-list-tile-title class="v-list-new">
                  <v-btn
                    small
                    color="#EB7704"
                    class="button"
                    @click="downloadFile(22)"
                  >Informe Técnico</v-btn>
                </v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile> -->
            <v-list-tile>
              <v-list-tile-content>
                <v-list-tile-title class="v-list-new">
                  <v-btn
                    small
                    color="#EB7704"
                    class="button"
                    @click="downloadFile(8)"
                  >Metodología PEI</v-btn>
                </v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
        </v-navigation-drawer>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import img1 from "../../assets/170.jpg";

import img2 from "../../assets/carruselFuturo/1.jpg";
import img3 from "../../assets/carruselFuturo/2.jpg";
import img4 from "../../assets/carruselFuturo/3.jpg";
import img5 from "../../assets/carruselFuturo/4.jpg";
import img6 from "../../assets/carruselFuturo/5.jpg";
import img7 from "../../assets/carruselFuturo/6.jpg";
import img8 from "../../assets/carruselFuturo/7.jpg";
import img9 from "../../assets/carruselFuturo/8.jpg";
import img10 from "../../assets/carruselFuturo/9.jpg";
import img11 from "../../assets/carruselFuturo/10.jpg";

export default {
  data() {
    return {
      carousel: [
        img2,
        img3,
        img4,
        img5,
        img6,
        img7,
        img8,
        img9,
        img10,
        img11,
      ],
      misionActual: "",
      visionActual: "",
      img1: img1,
      type: "",
      usuario: "",
      auth: {
        headers: { Authorization: "" + this.$session.get("jwt") }
      },
      ccComplete: {
        id: "",
        ccValor: "",
        ccNombre: "",
        esMayor: "",
        tipoUnidad: ""
      }
    };
  },

  created() {
    this.usuario = this.$session.getAll().email;
    this.type = this.$session.getAll().userType;
    this.ccComplete = this.$session.getAll().ccData;
    //console.log(this.usuario);
    this.getMision();
    this.getVision();
    axios
      .get(
        process.env.ROOT_API + "/uploadFileDcaEtc/getByCcValor?ccValor=0",
        this.auth
      )
      .then(response => {
        this.filesDca = response.data;
        //console.log(this.filesDca);
        //console.log(this.filesDca["dge"][1]);
      })
      .catch(error => {
        console.error(error);
      });
  },

  methods: {
    getMision() {
      axios
        .get(
          process.env.ROOT_API +
            "/mision/getAllByCC?ccValor=" +
            this.ccComplete.ccValor,
          this.auth
        )
        .then(response => {
          this.misionActual = response.data[0].actual;
        })
        .catch(error => {
          console.error(error);
        });
    },

    getVision() {
      axios
        .get(
          process.env.ROOT_API +
            "/vision/getAllByCC?ccValor=" +
            this.ccComplete.ccValor,
          this.auth
        )
        .then(response => {
          this.visionActual = response.data[0].actual;
        })
        .catch(error => {
          console.error(error);
        });
    },
    downloadFile(index) {
      //console.log("Descargando archivo ....");
      var pathFile = this.convertPath(this.filesDca.dge[index]["path"]);
      var nameFile = this.filesDca.dge[index]["name"];
      //console.log(nameFile);
      axios
        .get(
          process.env.ROOT_API +
            "/uploadFileDcaEtc/downloadFile?dir=" +
            pathFile,
          {
            responseType: "arraybuffer",
            headers: { Authorization: "" + this.$session.get("jwt") }
          }
        )
        .then(response => {
          //console.log("archivo descargado ....");
          //console.log(response);
          this.forceFileDownload(response, nameFile);
        })
        .catch(error => {
          console.error(error);
        });
    },

    convertPath(string) {
      var info = string.split("\\").join("/");
      return info;
    },
    forceFileDownload(response, nameFile) {
      //console.log("Aqui va el header");
      //console.log(response.headers);
      const url = window.URL.createObjectURL(
        new Blob([response.data], { type: response.headers["content-type"] })
      );
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", nameFile); //or any other extension
      document.body.appendChild(link);
      link.click();
    }
  }
};
</script>

<style scoped>
.v-card {
  margin-bottom: 1%;
  padding-right: 3%;
  padding-left: 3%;
  padding-top: 0.5%;
  border: none !important;
}

.top {
  margin-top: 50px;
}

.bot {
  margin-bottom: 50px;
}

.h1 {
  font-size: 25px !important;
  color: grey !important;
}

.h2 {
  font-size: 15px !important;
  color: grey !important;
}

.pull {
  text-align: left;
}

.line {
  border-right: 5px solid rgb(253, 165, 50);
}

.line2 {
  border-top: 5px solid rgb(253, 165, 50) !important;
}

.drawner {
  width: 200px !important;
  height: 300px !important;
  margin-left: 15px !important;
  margin-top: 30px !important;
  text-decoration: none !important;
  background-color: #f1f1f1 !important;
  border-left: 1px solid black !important;
}

.font {
  color: white !important;
}

.bot {
  margin-bottom: 50px !important;
}

.containerStyle2 {
  width: 100% !important;
  height: 400px !important;
  margin-top: 10px !important;
}
.video {
  width: 100% !important;
  margin-top: 10px !important;
  height: 400px;
}

.containerStyle1 {
  width: 100%;
  margin-top: 25%;
  margin-bottom: 50px;
}

.pull {
  text-align: justify;
}

.v-btn__content {
  font-size: 10px !important;
}

.theme--light.v-btn {
  color: white;
}

.v-btn {
  font-size: 10px;
  border-radius: 50px;
}

.v-list-new {
  height: 100% !important;
}
.lower-card {
  height: 100% !important;
  width: 100% !important;
  background-color: #394049 !important;
  border-radius: 0% !important;
  text-align: justify !important;
  padding: 3% !important;
  margin: 0% !important;
}
.upper-card {
  height: auto !important;
  width: 100% !important;
  background-color: #b1b1b1 !important;
  border-radius: 0% !important;
  text-align: justify !important;
  padding: 3% !important;
  margin: 0% !important;
}

.mid-dialog-card {
  width: 100% !important;
}

.text-mision-propuesta {
  color: rgb(255, 255, 255);
  font-size: 13px;
}
.text-mision {
  color: rgb(0, 0, 0);
  font-size: 13px;
}

.titlep {
  margin-top: 0;
  color: #ec6a12;
}
</style>



// WEBPACK FOOTER //
// src/components/diagnosticoEstrategico/Intro.vue